export default __webpack_public_path__ + "static/media/AdBlue.78b0b05a.svg";